import { render, staticRenderFns } from "./ForumChatThreadCardHeaderProfile.vue?vue&type=template&id=967c5832&scoped=true"
import script from "./ForumChatThreadCardHeaderProfile.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardHeaderProfile.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardHeaderProfile.vue?vue&type=style&index=0&id=967c5832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c5832",
  null
  
)

export default component.exports